import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { SnUser } from '@lib/api/entities';

// TODO Migrate to form generator
@Component({
  selector: 'sn-organization-form',
  templateUrl: './organization-form.component.html',
  styleUrls: ['./organization-form.component.scss'],
})
export class SnOrganizationFormComponent implements OnInit {
  @Input()
  public currentUserId: string;

  @Input()
  public isLoading = false;

  @Input()
  public users: SnUser[];

  @Output()
  public readonly send = new EventEmitter<Object>();

  public exceptionList: string[] = [];
  public form: UntypedFormGroup;
  public patchedUsers: SnUser[] = [];

  constructor(
    private readonly _formBuilder: UntypedFormBuilder,
    private readonly _matDialogRef: MatDialogRef<SnOrganizationFormComponent>,
    private readonly _cd: ChangeDetectorRef,
  ) {}

  get nameControl(): AbstractControl {
    return this.form.get('name');
  }

  get publicityControl(): AbstractControl {
    return this.form.get('publicity');
  }

  get hideSystemNotificationsControl(): AbstractControl {
    return this.form.get('hideSystemNotifications');
  }

  public cancel(): void {
    this._matDialogRef.close();
  }

  public ngOnInit(): void {
    this._initForm();

    this.exceptionList.push(this.currentUserId);
    if (this.users?.length) {
      this.patchedUsers = this.users;
    }
  }

  public sendFormData(): void {
    const data = this.form.value;
    this.send.emit(data);
    this._cd.detectChanges();
  }

  private _initForm(): void {
    this.form = this._formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(256)]],
      users: [[]],
      publicity: [true, Validators.required],
      hideSystemNotifications: [false],
    });
  }
}
